import { createActions, createReducer } from 'reduxsauce'

import DetalhesEmpenhoService from '../../servicos/DetalhesEmpenhoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaOperacoesEmpenhoInicio: [],
    buscaOperacoesEmpenhoSucesso: ['operacoesEmpenho'],
    buscaOperacoesEmpenhoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    selecionado: null,
}

// Ação para busca completa
Creators.buscaOperacoesEmpenho = filtro => {
    return dispatch => {
        dispatch(Creators.buscaOperacoesEmpenhoInicio())
        let serv = new DetalhesEmpenhoService()
        return serv
            .consultarOperacoes(filtro)
            .then(response => dispatch(Creators.buscaOperacoesEmpenhoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaOperacoesEmpenhoErro(error)))
    }
}

const buscaOperacoesEmpenhoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaOperacoesEmpenhoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaOperacoesEmpenhoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.operacoesEmpenho, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_OPERACOES_EMPENHO_INICIO]: buscaOperacoesEmpenhoInicio,
    [Types.BUSCA_OPERACOES_EMPENHO_ERRO]: buscaOperacoesEmpenhoErro,
    [Types.BUSCA_OPERACOES_EMPENHO_SUCESSO]: buscaOperacoesEmpenhoSucesso,
})
